import { createTheme } from '@mui/material/styles';

// Mario design tokens mapped to MUI theme
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0B6AE6', dark: '#084EBC', light: '#93C5FD' },
    success: { main: '#0FB77A' },
    warning: { main: '#F59E0B' },
    error:   { main: '#EF4444' },
    text:    { primary: '#0F172A', secondary: '#475569' },
    divider: '#E2E8F0',
    background: { default: '#FFFFFF', paper: '#FFFFFF' }
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    h1:{ fontSize:'2.25rem', fontWeight:600 },
    h2:{ fontSize:'1.75rem', fontWeight:600 },
    h3:{ fontSize:'1.5rem',  fontWeight:600 },
    h4:{ fontSize:'1.25rem', fontWeight:600 },
    body1:{ fontSize:'1rem', lineHeight:1.5 },
    body2:{ fontSize:'0.875rem', lineHeight:1.45 },
    button:{ textTransform:'none', fontWeight:600 }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '10px 16px',
          boxShadow: 'none',
          ':focus-visible': {
            outline: 'none',
            boxShadow: '0 0 0 2px #FFFFFF, 0 0 0 4px #0B6AE6'
          }
        },
        containedPrimary: { boxShadow: 'none' }
      }
    },
    MuiLink: { 
      styleOverrides: { 
        root: { color: '#084EBC', textUnderlineOffset: '2px' }
      } 
    },
    MuiPaper: { styleOverrides: { root: { borderRadius: 12 } } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          '& fieldset': { borderColor: '#E2E8F0' },
          '&.Mui-focused fieldset': { borderColor: '#0B6AE6', borderWidth: 2 }
        }
      }
    }
  }
});

export default theme;

